import { Text } from '@buffer-mono/popcorn'

import type { ValidHeader } from './validators'

import styles from './CsvExampleTable.module.css'

import type { JSX } from 'react'

interface CsvExampleTableProps {
  headers: ValidHeader[]
}

/** Sample values shown in the first data row to illustrate the expected format. */
const exampleValues: Record<ValidHeader, string> = {
  text: 'Big news today! 🎉',
  image_url: 'https://buffer.com/photo.jpg',
  tags: 'Marketing',
  posting_time: '2026-07-29 13:29',
  board_name: 'Recipes',
  title: 'Post title',
  description: 'Short description',
  alt_text: 'Image description',
  link: 'https://buffer.com',
}

export const CsvExampleTable = ({
  headers,
}: CsvExampleTableProps): JSX.Element => {
  return (
    <div className={styles.csvExampleTable}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th scope="col" aria-label="Row number" />
            {headers.map((header) => (
              <th key={header}>
                <Text size="sm" color="subtle" weight="medium">
                  {header}
                </Text>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Text size="sm" color="subtle">
                1
              </Text>
            </td>
            {headers.map((header) => (
              <td key={header}>
                <Text size="sm" color="subtle">
                  {exampleValues[header]}
                </Text>
              </td>
            ))}
          </tr>
          <tr>
            <td>
              <Text size="sm" color="subtle">
                2
              </Text>
            </td>
            {headers.map((header) => (
              <td key={`empty-${header}`} aria-label="No value" />
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  )
}
